<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Ajouter un nouveau produit</strong>
          </div>
          <b-form>
            <!-- <b-form-group label="Famille *" label-for="basicSelect">
              <b-form-select
                id="basicSelect"
                :plain="true"
                :options="famillesOptions"
                v-model="selectedFamille">
              </b-form-select>
              <span class="field-error">{{ errors.selectedFamille }}</span>
            </b-form-group> -->
            <b-form-group label="Type *" label-for="basicSelect">
              <b-form-select
                id="basicSelect"
                :plain="true"
                :options="typesOptions"
                v-model="selectedType">
              </b-form-select>
              <span class="field-error">{{ errors.selectedType }}</span>
            </b-form-group>
            <b-form-group label="Code produit *" label-for="code_produit">
              <b-form-input
                id="code_produit"
                type="text"
                :class="{hasError: errors.code_produit !== ''}"
                v-model="code_produit"
              />
              <span class="field-error">{{ errors.code_produit }}</span>
            </b-form-group>
            <b-form-group label="Description *" label-for="description">
              <b-form-input
                id="description"
                type="text"
                :class="{hasError: errors.description !== ''}"
                v-model="description"
              />
              <span class="field-error">{{ errors.description }}</span>
            </b-form-group>
            <b-form-group label="Précision" label-for="precision">
              <b-form-input
                id="precision"
                type="text"
                :class="{hasError: errors.precision !== ''}"
                v-model="precision"
              />
              <span class="field-error">{{ errors.precision }}</span>
            </b-form-group>
            <b-form-group id="fieldset-onSale" label="Le produit est-il toujours disponible à la vente *" label-for="radio-group-onSale">
              <b-form-radio-group id="radio-group-onSale" v-model="onSale" name="radio-sub-component">
                <b-form-radio value="true">Oui</b-form-radio>
                <b-form-radio value="false">Non</b-form-radio>
              </b-form-radio-group>
              <span class='field-error'>{{ errors.onSale }}</span>
            </b-form-group>
            
            <div class="mt-5" slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"/> Liste des produits
              </b-button>
              <b-button type="button" @click="save" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"/> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { getAccessToken, getBaseUrl, getIdToken, getProvider } from '@/utils/auth'
  import { isEmpty } from "@/utils/fileHelper"

  export default {
    name: "Add",
    data() {
      return {
        code_produit: "",
        description: "",
        precision: "",
        onSale: true,
        famillesOptions: [],
        selectedFamille: null,
        typesOptions: [],
        selectedType: null,
        errors: {
          code_produit: "",
          description: "",
          precision: "",
          onSale: "",
          selectedFamille: "",
          selectedType: "",
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      // this.getFamillesProduit();
      this.getTypesProduit();
    },
    methods: {
      getFamillesProduit() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceGestion/produit/gestion-famille')
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            const famillesProduit = response.data.famillesProduit;
            for (let i = 0; i < famillesProduit.length; i++) {
              this.famillesOptions.push({
                text: famillesProduit[i].libelle,
                value: famillesProduit[i].id
              });
            }
          });
      },
      getTypesProduit() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceGestion/produit/gestion-type')
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            const typesProduit = response.data.typesProduit;
            for (let i = 0; i < typesProduit.length; i++) {
              this.typesOptions.push({
                text: typesProduit[i].libelle_court,
                value: typesProduit[i].id
              });
            }
          });
      },
      save() {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let dataPost = {};
          dataPost.code_produit = this.code_produit;
          dataPost.description = this.description;
          dataPost.precision = this.precision;
          dataPost.onSale = this.onSale;
          // dataPost.familleId = this.selectedFamille
          dataPost.typeId = this.selectedType
          this.$axios
            .post("/espaceGestion/famille-produit/produit", dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Création avec succès",
                text: "Le produit a été bien crée",
                showConfirmButton: false,
                timer: 5000
              });
              this.returnBack()
            })
            .catch(() => {
              this.$store.commit("IS_LOADING", false);
              this.handleError();
            });
        }
      },
      returnBack() {
        this.$router.push({path: "/espace-gestion/famille-produit/list"});
      },
      validateData() {
        this.clearErrors()
        let valid = true;
        if (isEmpty(this.code_produit)) {
          this.errors.code_produit = "Le code produit est obligatoire";
          valid = false;
        }
        if (isEmpty(this.description)) {
          this.errors.description = "La description est obligatoire";
          valid = false;
        }
        // if (this.selectedFamille === null) {
        //   this.errors.selectedFamille = "Le choix de la famille est obligatoire";
        //   valid = false;
        // }
        if (this.selectedType === null) {
          this.errors.selectedType = "Le choix du type est obligatoire";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.code_produit = "";
        this.errors.description = "";
        this.errors.selectedFamille = "";
        this.errors.selectedType = "";
      },
      handleError() {
        this.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Un problème est survenu, merci de contacter l\'administrateur',
          showConfirmButton: false,
          timer: 5000
        });
      }
    }
  }
</script>
